import React, { useMemo } from 'react';
import { ComboBox } from '@carbon/react';
import { useEmployees } from 'src/hooks/useEmployees';

interface EmployeeSelectorProps {
  value: string | undefined | null;
  invalid?: boolean;
  branchId: string | undefined;
  onChange: (value: string | null) => void;
  hideTitle?: boolean;
  placeholderText?: string;
}

const EmployeeSelector = React.memo((props: EmployeeSelectorProps) => {
  const { data: employees } = useEmployees();

  // `useEmployees` returns raw employment records, NOT rows from `toEmployeeRow`, so the
  // account-less fallback has to be applied here too: an employee hired without a portal
  // account has no `user` relation at all and keeps their name on the employment record
  // instead (the linked user wins when present — auth is authoritative, spec decision 6).
  // `?? ''` plus the trim covers the row where neither source carries a name, so an option
  // never reads "undefined undefined".
  const employeesSelectionItems = useMemo(() => {
    return employees?.data
      ?.filter((item) => item.restaurantBranchId === props.branchId)
      .map((item) => ({
        id: item.id,
        text: `${item.user?.firstName ?? item.firstName ?? ''} ${item.user?.lastName ?? item.lastName ?? ''}`.trim(),
      }));
  }, [employees?.data, props.branchId]);

  return (
    <ComboBox
      items={employeesSelectionItems}
      placeholder={props.placeholderText || 'Filter...'}
      invalid={props.invalid}
      selectedItem={props.value ? employeesSelectionItems?.find((item) => item.id === props.value) : null}
      onChange={(e) => props.onChange(e.selectedItem?.id)}
      itemToString={(item) => (item ? item.text : '')}
      titleText={!props.hideTitle ? 'Select a employee' : null}
    />
  );
});

export default EmployeeSelector;
